// extracted by mini-css-extract-plugin
export default {"columnSpace":"ZwgLevels_columnSpace__mVRkP"};